import { Component, inject } from '@angular/core';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { CategoryStore } from '@app2/store/category/category.store';
import { FapsStore } from '@app2/store/faps/faps.store';
import { VideosStore } from '@app2/store/videos/videos.store';
import { StarsStore } from '@app2/store/stars/stars.store';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RouterLink } from '@angular/router';
import { FapRepository } from '@core/repositories';
import { FapWebRepository } from '@data/repositories';
import { SubscribeBannerComponent } from '@app2/shared/components/subscribe-banner/subscribe-banner.component';
import { Store } from '@ngrx/store';
import { searchSelectors } from '@app2/store/search/search.selectors';
import { searchActions } from '@app2/store/search/search.actions';
import { RecyclerViewComponent } from '@app2/shared/components/recycler-view/recycler-view.component';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { AnalyticsDirective } from '@app2/core/directives/analytics/analytics.directive';

@UntilDestroy()
@Component({
  selector: 'sens-search',
  imports: [
    IconComponent,
    RouterLink,
    SubscribeBannerComponent,
    RecyclerViewComponent,
    AnalyticsDirective,
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  providers: [
    CategoryStore, FapsStore, VideosStore, StarsStore,
    { provide: FapRepository, useClass: FapWebRepository },
  ],
  standalone: true,
})
export class SearchComponent {

  private store = inject(Store);

  public faps$ = this.store.selectSignal(searchSelectors.selectFaps);

  public isLoading$ = this.store.selectSignal(searchSelectors.selectFapsIsLoading);

  public nextPage$ = this.store.selectSignal(searchSelectors.selectFapsNextPage);

  public query$ = this.store.selectSignal(searchSelectors.selectQuery);

  public onIntersecting(value: boolean) {
    if (value) {
      if (!this.isLoading$() && !!this.nextPage$()) {
        this.store.dispatch(searchActions.loadFaps({ ps: 20, p: this.nextPage$()!, q: this.query$() ?? '' }));
      }
    }

  }

  protected readonly AnalyticsEventsEnum = AnalyticsEventsEnum;


}
